var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"main_container",attrs:{"type":"flex"}},[_c('base-header',[_c('i',{staticClass:"el-icon-arrow-left back",on:{"click":_vm.goBack}}),_vm._v("编辑商品")]),_c('personal-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }